export const locale = {
  lang: "it",
  data: {
    MENU: {
      CUSTOMERS_TYPE_PLURAL: "Tipologie clienti",
      CUSTOMERS_TYPE_SINGULAR: "Tipologia cliente",
      CUSTOMERS_FTE_SUBJECT_TYPE_PLURAL: "Tipologia di soggetti FTE",
      CUSTOMERS_TRACK_FINANCE_RELEVANCE_PLURAL: "Rilevanza per la tracciabilità flussi finanziari clienti",
      CUSTOMERS_SERVICES_TRACK_PLURAL: "Tracciati servizi",
    },
    ERRORS: {
      FIELD_SUBJECT_TYPE: "Il campo tipologia cliente è obbligatorio",
      FIELD_REQUIRED: "Il campo è obbligatorio",
    },
    ALERT: {
      SUCCESS_ADD_CUSTOMER_TYPE: "Tipologia cliente aggiunta con successo",
      ERROR_ADD_CUSTOMER_TYPE: "Errore durante l'aggiunta della tipologia cliente",
      SUCCESS_EDIT_CUSTOMER_TYPE: "Tipologia cliente modificata con successo",
      ERROR_EDIT_CUSTOMER_TYPE: "Errore durante la modifica della tipologia cliente",
      SUCCESS_DELETE_CUSTOMER_TYPE: "Tipologia cliente eliminata con successo",
      ERROR_DELETE_CUSTOMER_TYPE: "Errore durante l'eliminazione della tipologia cliente",
      SUCCESS_DELETE_FTE_SUBJECT_TYPE: "Tipologia di soggetti FTE eliminata con successo",
      ERROR_DELETE_FTE_SUBJECT_TYPE: "Errore durante l'eliminazione della tipologia di soggetti FTE",
      SUCCESS_EDIT_FTE_SUBJECT_TYPE: "Tipologia di soggetti FTE modificata con successo",
      ERROR_EDIT_FTE_SUBJECT_TYPE: "Errore durante la modifica della tipologia di soggetti FTE",
      SUCCESS_ADD_FTE_SUBJECT_TYPE: "Tipologia di soggetti FTE aggiunta con successo",
      ERROR_ADD_FTE_SUBJECT_TYPE: "Errore durante l'aggiunta della tipologia di soggetti FTE",
      SUCCESS_ADD_TRACK_FINANCE_RELEVANCE: "Rilevanza per la tracciabilità flussi finanziari clienti aggiunta con successo",
      ERROR_ADD_TRACK_FINANCE_RELEVANCE: "Errore durante l'aggiunta della rilevanza per la tracciabilità flussi finanziari clienti",
      SUCCESS_EDIT_TRACK_FINANCE_RELEVANCE: "Rilevanza per la tracciabilità flussi finanziari clienti modificata con successo",
      ERROR_EDIT_TRACK_FINANCE_RELEVANCE: "Errore durante la modifica della rilevanza per la tracciabilità flussi finanziari clienti",
      SUCCESS_DELETE_TRACK_FINANCE_RELEVANCE: "Rilevanza per la tracciabilità flussi finanziari clienti eliminata con successo",
      ERROR_DELETE_TRACK_FINANCE_RELEVANCE: "Errore durante l'eliminazione della rilevanza per la tracciabilità flussi finanziari clienti",
      SUCCESS_ADD_SERVICES_TRACK: "Servizio tracciato aggiunto con successo",
      ERROR_ADD_SERVICES_TRACK: "Errore durante l'aggiunta del servizio tracciato",
      SUCCESS_EDIT_SERVICES_TRACK: "Servizio tracciato modificato con successo",
      ERROR_EDIT_SERVICES_TRACK: "Errore durante la modifica del servizio tracciato",
      SUCCESS_DELETE_SERVICES_TRACK: "Servizio tracciato eliminato con successo",
      ERROR_DELETE_SERVICES_TRACK: "Errore durante l'eliminazione del servizio tracciato",
    },
    ADD_NEW_CUSTOMER_TYPE: "Aggiungi nuova tipologia cliente",
    ADD_NEW_FTE_SUBJECT_TYPE: "Aggiungi nuova tipologia di soggetti FTE",
    ADD_NEW_TRACK_FINANCE_RELEVANCE: "Aggiungi nuova rilevanza per la tracciabilità flussi finanziari clienti",
    EDIT_CUSTOMER_TYPE: "Modifica tipologia cliente",
    EDIT_FTE_SUBJECT_TYPE: "Modifica tipologia di soggetti FTE",
    EDIT_TRACK_FINANCE_RELEVANCE: "Modifica rilevanza per la tracciabilità flussi finanziari clienti",
    DELETE_CUSTOMER_TYPE: "Elimina tipologia cliente",
    DELETE_FTE_SUBJECT_TYPE: "Elimina tipologia di soggetti FTE",
    DELETE_TRACK_FINANCE_RELEVANCE: "Elimina rilevanza per la tracciabilità flussi finanziari clienti",
    EXTERNAL_SITE_QUESTION: "Sede estera?",
    HEAD_OFFICE_QUESTION: "Vuoi selezionare questa come sede legale?",
    ENABLE_CIG_AND_CUP: "Abilita campi CIG e CUP",
    ENABLED_CIG_AND_CUP: "Campi CIG e CUP abilitati",
    FIELD_LENGTH: "Lunghezza campo",
    CUSTOMERS_INVOICE_DATA: "Dati fatturazione",
    PAYMENT_TERMS: "Termini di pagamento",
    FTE_TYPE_SUBJECT: "Tipologia di Soggetto FTE",
    SDI_CODE: "Codice SDI",
    IVA_SPLIT_PAYMENT: "IVA split Payment/Sospesa",
    ALTERNATIVE_CODE: "Codice alternativo",
    TRACK_FINANCIAL_RELEVANCE: "Rilevante per tracciabilità flussi finanziari",
    PHONE_NUMBER: "Numero di telefono",
    PHONE_NUMBER_2: "Numero di telefono 2",
    FAX_NUMBER: "Numero di fax",
    PERSON_LASTNAME: "Cognome",
    PERSON_FIRSTNAME: "Nome",
    PERSON_GENDER: "Genere",
    PERSON_BIRTH_CITY: "Città di nascita",
    PERSON_BIRTH_DATE: "Data di nascita",
    ADD_NEW_TRACK_SERVICE: "Aggiungi nuovo servizio tracciato",
    EDIT_TRACK_SERVICE: "Modifica servizio tracciato",
    LOADING_COMMISSIONS: "Caricamento commesse in corso...",
  },
};
